<div class="card">
  <h3 class="font-semibold text-base mb-3">Attachments</h3>

  @if (errorMessage) {
    <p class="text-danger-base text-sm mb-2">{{errorMessage}}</p>
  }

  <div class="attachment-header">
    <label class="btn-inverse btn-compact btn-small upload-btn">
      <input type="file" class="hidden-input" (change)="onAttachmentSelected($event)">
      <i class="pi" [ngClass]="uploading ? 'pi-spin pi-spinner' : 'pi-upload'"></i>
      <span class="ml-1">{{uploading ? 'Uploading...' : 'Upload'}}</span>
    </label>
  </div>

  @if (attachments.length === 0) {
    <p class="text-grey-500 text-sm">No attachments.</p>
  }

  @for (a of attachments; track a) {
    <div class="attachment-row">
      <div class="flex items-center gap-3">
        @if (isImage(a)) {
          <img [src]="attachmentSrc(a.GUID)" alt="Preview" class="attachment-thumb">
        }
        <p class="text-sm font-semibold">{{a.FileName}}</p>
      </div>
      <div class="flex gap-2">
        <button pButton class="btn-inverse btn-compact btn-xs" type="button" (click)="onDownload(a.GUID)">
          <i class="pi pi-download"></i>
        </button>
        <button pButton class="btn-danger btn-compact btn-xs" type="button" (click)="onRemove(a.GUID, $event)">
          <i class="pi pi-trash"></i>
        </button>
      </div>
    </div>
  }
</div>
